import { createFileRoute } from "@tanstack/react-router";
import { ModuleGuard } from "@/components/auth/ModuleGuard";
import ChecklistsPage from "@/pages/ChecklistsPage";

export const Route = createFileRoute("/_app/checklists")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ModuleGuard module="prospects">
      <ChecklistsPage />
    </ModuleGuard>
  );
}
